import i18n from 'shared/lib/i18n';

import ViewExportContainer from '../ViewExport/ViewExportContainer';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);
  const rows = [];
  data.forEach(({ name, countriesList, enabled, initialValueForBuildings }) => {
    rows.push([
      name,
      countriesList,
      enabled ? i18n.t('common.yes') : i18n.t('common.no'),
      initialValueForBuildings ? i18n.t('common.yes') : i18n.t('common.no'),
    ]);
  });
  return { headers, rows };
};

const DeliveryTypesListExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default DeliveryTypesListExport;
